import { Box, FormControl, FormHelperText } from "@mui/material";
import Label from "./Label";

const formFieldSx = {
  width: "100%",
};

export default function FormField({
  name,
  label,
  labelAddon,
  error,
  hint,
  children,
  disabled,
  required,
  labelSx,
}) {
  return (
    <FormControl
      fullWidth
      error={!!error}
      disabled={disabled}
      required={required}
      sx={formFieldSx}
    >
      {label && (
        <Box display="flex" justifyContent="space-between" mb={1}>
          <Label sx={labelSx} name={name}>
            {label}
          </Label>
          {labelAddon && <Box>{labelAddon}</Box>}
        </Box>
      )}

      {children}

      {(error || hint) && (
        <Box display="flex" gap={2}>
          {hint && <FormHelperText>{hint}</FormHelperText>}
          {error && <FormHelperText>{error}</FormHelperText>}
        </Box>
      )}
    </FormControl>
  );
}
